"use client";

import { SiteTemplatePageSectionTypeBlogsSettingModel } from "@/Apis/ClinicApi";
import { Helper } from "@/Helpers";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { BlogsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedBlogsSection from "../Components/GeneratedBlogsSection";

const Blogs: FC<BlogsSectionProps> = (props) => {
  return <GeneratedBlogsSection {...props} />;
};

export default Blogs;

export const defaultBlogsSetting: SiteTemplatePageSectionTypeBlogsSettingModel =
{
  Title: "",
  Description: "",
  Appearance: Helper.centerOptionObjectToCenterOptionModel(
    CenterOptions.SiteTemplate.SiteTemplateSettings
      .SiteTemplateBlogsAppearance.Home1,
  ),
  ViewAllButtonDisplayStatus: Helper.centerOptionObjectToCenterOptionModel(CenterOptions.Enum.Status.InActive),
};
